// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const portalRoot = document.getElementById('portals')!;
